module.exports = __webpack_public_path__ + "static/img/crown.64703d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/crown.png
// module id = J5DO
// module chunks = 0